module.exports = __webpack_public_path__ + "img/wait-status.04e6843a.svg";